import React, { useState } from 'react';

import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

import { DesktopIcon } from 'assets/icons/desktop-icon';
import { MobilePhoneIcon } from 'assets/icons/mobile-phone-icon';
import { Type } from 'src/app/components/lib/type';
import { userDispensariesAtom } from 'src/app/state/user-dispensaries';

import { SlideContainer } from '../../../workflows/workflow-campaign-builder/shared/styles';
import { useTemplateBuilderContext } from '../wizard/builder-context';

export function CampaignTemplateContentReview() {
  const [showMobilePreview, setShowMobilePreview] = useState(false);

  // state
  const [builderState] = useTemplateBuilderContext();
  const { htmlBody } = builderState;

  const { locProfile } = useRecoilValue(userDispensariesAtom);

  const emailIsActive = locProfile.UseEmailMarketing ?? false;
  const smsIsActive = locProfile.UseSMSMarketing ?? false;

  return (
    <SlideContainer>
      <CardsContainer>
        {(emailIsActive || smsIsActive) && (
          <EmailPreviewContainer>
            <EmailPreviewHeader>
              <Type px={14} weight='semibold'>
                Content
              </Type>
              <EmailPreviewViewSwitcher>
                <PreviewModeButton $selected={!showMobilePreview} onClick={() => setShowMobilePreview(false)}>
                  <DesktopIcon />
                  Desktop
                </PreviewModeButton>
                <PreviewModeButton $selected={showMobilePreview} onClick={() => setShowMobilePreview(true)}>
                  <MobilePhoneIcon />
                  Mobile
                </PreviewModeButton>
              </EmailPreviewViewSwitcher>
            </EmailPreviewHeader>
            <EmailPreviewBody>
              <EmailPreviewBodyContainer $isMobilePreview={showMobilePreview}>
                <iframe frameBorder='0' height='575px' srcDoc={htmlBody} title='email-preview' width='100%' />
              </EmailPreviewBodyContainer>
            </EmailPreviewBody>
          </EmailPreviewContainer>
        )}
      </CardsContainer>
    </SlideContainer>
  );
}

const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sizes-50);
  width: 100%;
  align-items: center;
  margin-top: var(--sizes-60);
`;
const EmailPreviewContainer = styled.div`
  width: 100%;
  max-width: 850px;
  margin-bottom: var(--sizes-60);
  background-color: var(--color-brand-primary-white);
  border-radius: 8px;
  border: 1px solid var(--color-gray-20);
`;
const EmailPreviewHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--sizes-40) var(--sizes-60);
  border-bottom: 1px solid var(--color-gray-20);
`;
const EmailPreviewViewSwitcher = styled.div`
  background-color: var(--color-gray-10);
  padding: var(--sizes-20);
  border-radius: 7px;
  border: 1px solid var(--color-gray-20);
  display: flex;
  align-items: center;
`;
const PreviewModeButton = styled.div<{ $selected: boolean }>`
  background-color: ${({ $selected }) => ($selected ? 'var(--color-brand-primary-white)' : 'transparent')};
  border-radius: 7px;
  font: var(--font-extra-small-12pt-semibold);
  width: 97px;
  height: 30px;
  display: flex;
  align-items: center;
  padding: 6px var(--sizes-30);
  gap: var(--sizes-20);
`;
const EmailPreviewBody = styled.div`
  width: 100%;
  padding: var(--sizes-60);
  display: flex;
  justify-content: center;
  align-items: center;
`;
const EmailPreviewBodyContainer = styled.div<{ $isMobilePreview: boolean }>`
  width: ${({ $isMobilePreview }) => ($isMobilePreview ? '390px' : '100%')};
`;
